import { types } from "api";
import { createContext } from "react";

/**
 * Whether we're authenticated or not can be determined by knowing what role
 * we have.
 */
export type AuthStatusRole = "unauthenticated" | types.RoleType;

export interface UseAuthStatusPayload {
	isLoading: boolean;
	role: AuthStatusRole;

	/**
	 * This is used when an authentication action has occurred outside of
	 * `useAuthStatus`.
	 */
	setRole: (roleType?: AuthStatusRole | types.RoleType[]) => void;
}

export const AuthStatusContext = createContext<UseAuthStatusPayload>({
	isLoading: false,
	setRole: () => {},
	role: "unauthenticated",
});
